export const PAGENO_ACTION_TYPES = {
  SET_PAGENO_VALUE: "SET_PAGENO_VALUE",
};
